import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UpdatevesselDataComponent } from '../updatevessel-data/updatevessel-data.component';

const routes: Routes = [
  {
    path: '',
    component: UpdatevesselDataComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UpdatevesselDataRoutingModule {}